// import {
//   faBrain,
//   faChartLine,
//   faLeaf,
//   faSmile,
//   faUsers,
//   faUtensils,
//   faWind,
// } from "@fortawesome/free-solid-svg-icons";

// import React from "react";

// import {
//   BannerSection,
//   ContactForm,
//   FeatureTilesSection,
//   Header,
//   ListSection,
//   TransformSection,
// } from "../../../components/template";

// const Thrive = () => {

//   const includedItems = [
//     {
//       icon: faBrain,
//       text:
//         "Deep work strategies for sharper focus and efficiency",
//     },

//     {
//       icon: faSmile,
//       text:
//         "Positive psychology tools to increase motivation and job satisfaction",
//     },

//     {
//       icon: faChartLine,
//       text:
//         "Growth mindset training to enhance focus and resilience",
//     },

//     {
//       icon: faLeaf,
//       text:
//         "Yogic techniques for boosting energy and stamina",
//     },

//     {
//       icon: faWind,
//       text:
//         "Stress-reducing mindfulness and breathwork practices",
//     },


//     {
//       icon: faUsers,
//       text:
//         "Activities to strengthen team connection and morale",
//     },
//   ];

//   const benefits = [
//     {
//       subhead:
//         "Short-Term Fix",

//       content:
//         "Motivation spikes temporarily but fades quickly after the event.",
//     },

//     {
//       subhead:
//         "Surface-Level Engagement",

//       content:
//         "Fun activities without meaningful emotional or mental transformation.",
//     },

//     {
//       subhead:
//         "One-Size-Fits-All",

//       content:
//         "Fails to address deeper individual wellbeing and team dynamics.",
//     },

//     {
//       subhead:
//         "No Daily Integration",

//       content:
//         "Temporary escape instead of sustainable long-term change.",
//     },
//   ];

//   const icon = "🚫";

//   const featp =
//     "Your team deserves more than quick escapes and temporary motivation — they deserve sustainable energy, focus, resilience, and wellbeing.";

//   const transformImage =
//     "/assets/thrive/t6.jpg";

//   const transformHeading =
//     "THRIVE’s Game-Changing Benefits";

//   const transformParagraph = (
//     <>
//       <strong>Outcome —</strong>
//       Aligned, energized, resilient,
//       and high-performing teams.
//     </>
//   );

//   const transformPoints = [
//     <>
//       <b>Laser Focus —</b>
//       Eliminate distractions and
//       sharpen attention.
//     </>,

//     <>
//       <b>Resilience & Stress Mastery —</b>
//       Thrive under pressure and
//       bounce back stronger.
//     </>,

//     <>
//       <b>Sustained Motivation —</b>
//       Increase engagement and
//       long-term productivity.
//     </>,

//     <>
//       <b>Physical Vitality —</b>
//       Prevent fatigue with practical
//       office-friendly wellness tools.
//     </>,

//     <>
//       <b>Stronger Team Synergy —</b>
//       Build trust, empathy, and
//       mindful collaboration.
//     </>,
//   ];

//   const ticons = [
//     "🔥",
//     "⚡",
//     "💪",
//     "🌟",
//     "🤝",
//   ];

//   const bannerp =
//     "💡 Happy, healthy teams don’t just work better — they thrive.";

//   const heading = (
//     <span>
//       Who is THRIVE For?
//     </span>
//   );

//   const features = [
//     {
//       icon: "⚡",
//       text:
//         "Teams facing stress, fatigue, and low motivation",
//     },

//     {
//       icon: "🎯",
//       text:
//         "Leaders seeking sharper focus and clarity",
//     },

//     {
//       icon: "📈",
//       text:
//         "Companies aiming for stronger engagement and productivity",
//     },

//     {
//       icon: "💖",
//       text:
//         "Organizations investing in long-term employee wellbeing",
//     },
//   ];

//   const mediaItems = [
//     {
//       type: "image",
//       src: "/assets/thrive/t1.jpg",
//     },

//     {
//       type: "image",
//       src: "/assets/thrive/t2.jpg",
//     },

//     {
//       type: "image",
//       src: "/assets/thrive/t3.jpg",
//     },

//     {
//       type: "image",
//       src: "/assets/thrive/t4.jpg",
//     },

//     {
//       type: "image",
//       src: "/assets/thrive/t5.jpg",
//     },

//     {
//       type: "image",
//       src: "/assets/thrive/t7.jpg",
//     },

//     {
//       type: "image",
//       src: "/assets/thrive/t8.jpg",
//     },

//     {
//       type: "image",
//       src: "/assets/thrive/t9.jpg",
//     },
//   ];

//   const para =
//     "Ready to break the cycle of burnout, stress, disengagement, and low productivity? Write to us now —";

//   const icons = [
//     "✨",
//     "🧘‍♂️",
//     "🏆",
//   ];

//   return (
//     <main className="bg-[#F7F1EA] overflow-hidden">

//       {/* ================================================= */}
//       {/* HERO */}
//       {/* ================================================= */}

// {/* ================================================= */}
// {/* HERO */}
// {/* ================================================= */}

// <section className="relative px-6 pt-14 pb-20">
//   <div className="absolute top-0 left-0 w-72 h-72 bg-[#E8C8A7]/30 blur-3xl rounded-full" />

//   <div className="relative max-w-[1200px] mx-auto">

//     {/* LABEL */}
//     <div className="text-center mb-5">
//       <div
//         className="
//           inline-flex
//           items-center
//           px-5
//           py-2
//           rounded-full
//           bg-[#FFF4E8]
//           border
//           border-[#F3DDC7]
//           text-primary
//           text-[11px]
//           tracking-[.18em]
//           uppercase
//           font-medium
//         "
//       >
//         Corporate Wellness Program
//       </div>
//     </div>

//     {/* HEADING */}
//     <div className="text-center mb-14">

//       <h1
//         className="
//           text-[clamp(42px,7vw,90px)]
//           font-bold
//           text-secondary
//           leading-tight
//           mb-5
//         "
//       >
//         THRIVE
//       </h1>

//       <h2
//         className="
//           text-xl
//           md:text-3xl
//           font-bold
//           text-primary
//           mb-6
//         "
//       >
//         Unlock Your Team's True Potential
//       </h2>

//       <p
//         className="
//           text-sm
//           md:text-base
//           leading-8
//           text-gray-700
//           max-w-4xl
//           mx-auto
//         "
//       >
//         Burnout, stress, fatigue, and distractions are silently draining
//         workplace performance and morale. THRIVE is a science-backed wellness
//         experience designed to boost resilience, focus, motivation, and team
//         energy sustainably.
//       </p>

//     </div>

//     {/* HERO MEDIA */}
//     <div
//       className="
//         relative
//         overflow-hidden
//         rounded-[34px]
//         shadow-[0_25px_70px_rgba(20,10,0,.08)]
//       "
//     >
//       <Header
//         description={[
//           "Tailored to your organization's needs & pain points",
//           "Built for sustainable wellbeing, engagement & productivity",
//           "Designed to create lasting behavioural transformation",
//         ]}
//         mediaItems={mediaItems}
//         showVideo={false}
//         icons={icons}
//       />
//     </div>
//   </div>
// </section>
//       {/* ================================================= */}
//       {/* TRANSFORM */}
//       {/* ================================================= */}

//       <TransformSection
//         imageSrc={transformImage}
//         altText="Thrive Benefits"
//         heading={transformHeading}
//         paragraph={transformParagraph}
//         points={transformPoints}
//         ticons={ticons}
//       />

//       {/* ================================================= */}
//       {/* INCLUDED */}
//       {/* ================================================= */}

//       <ListSection
//         items={includedItems}
//       />

//       {/* ================================================= */}
//       {/* FEATURE TILES */}
//       {/* ================================================= */}

//       <FeatureTilesSection
//         heading2="Why Traditional Corporate Wellness Falls Short"
//         benefits={benefits}
//         icon={icon}
//         featp={featp}
//       />

//       {/* ================================================= */}
//       {/* BANNER */}
//       {/* ================================================= */}

//       <BannerSection
//         heading={heading}
//         features={features}
//         bannerp={bannerp}
//       />

//       {/* ================================================= */}
//       {/* CONTACT */}
//       {/* ================================================= */}

//       <section className="py-24 px-6">

//         <div className="max-w-[1200px] mx-auto">

//           <div className="text-center mb-12">

//             <div
//               className="
//                 inline-flex
//                 items-center
//                 px-5
//                 py-2
//                 rounded-full
//                 bg-[#FFF4E8]
//                 border
//                 border-[#F3DDC7]
//                 text-[#C26B2E]
//                 text-[11px]
//                 tracking-[.18em]
//                 uppercase
//                 font-medium
//                 mb-6
//               "
//             >
//               Contact Us
//             </div>

//             <h2
//               className="
//                 text-[clamp(42px,6vw,82px)]
//                 leading-[.95]
//                 tracking-[-0.05em]
//                 text-[#2A140D]
//                 mb-6
//               "
//               style={{
//                 fontFamily:
//                   "'DM Serif Display', serif",
//               }}
//             >
//               Let Your Team
//               Thrive
//             </h2>

//             <p
//               className="
//                 text-[#5F5751]
//                 text-[17px]
//                 leading-9
//                 max-w-[760px]
//                 mx-auto
//               "
//             >
//               {para}
//             </p>
//           </div>

//           <ContactForm para="" />
//         </div>
//       </section>
//     </main>
//   );
// };
        
         
// export default Thrive;
import React from "react";
import { Link } from "react-router-dom";
const CorporateJourney = () => {
const programs = [
  {
    title: "INNER-EDGE",
    image: "../../../cw/CW14.JPG",
    link: "/corporate-wellness/inneredge",
  },
  {
    title: "INHANCE",
    image: "../../../cw/cw5.JPG",
    link: "/corporate-wellness/inhance",
  },
  {
    title: "INPOWER",
    image: 
         "../../../cw/CW4.JPG",

    link: "/corporate-wellness/inpower",
  },
  {
    title: "THRIVE",
    image: 
         "../../../cw/CW6.JPG",

    link: "/corporate-wellness/thrive",
  },
];
  return (
    <main className="bg-[#F7F1EA] min-h-screen">
      <section className="py-20 md:py-28 px-6">
        <div className="max-w-[1280px] mx-auto">
          {/* Label */}
          <div className="text-center mb-6">
            <div
              className="
                inline-flex
                items-center
                px-5
                py-2
                rounded-full
                bg-[#FFF4E8]
                border
                border-[#F3DDC7]
                text-primary
                text-[11px]
                tracking-[.18em]
                uppercase
                font-medium
              "
            >
              Corporate Transformation Journey
            </div>
          </div>

          {/* Heading */}
          <div className="max-w-5xl mx-auto text-center mb-16">
            <h1
              className="
                text-[clamp(40px,6vw,82px)]
                leading-[.95]
                tracking-[-0.05em]
                text-secondary
                mb-6
              "
            >
              A 4-Step Unique Program
              <br />
              for Your Team's Holistic Growth
              <br />& Inner Excellence
            </h1>

            <p
              className="
                text-[#5F5751]
                text-[17px]
                md:text-[18px]
                leading-9
                max-w-[760px]
                mx-auto
              "
            >
              A thoughtfully designed transformation journey that nurtures
              awareness, resilience, leadership, wellbeing, and sustainable
              high performance—one step at a time.
            </p>
          </div>

          {/* Cards */}
          <div
            className="
              grid
              grid-cols-1
              sm:grid-cols-2
              xl:grid-cols-4
              gap-8
            "
          >
{programs.map((program, index) => (
  <Link
    key={index}
    to={program.link}
    className="group block"
  >
    <div
      className="
        bg-white
        rounded-[32px]
        overflow-hidden
        shadow-[0_20px_60px_rgba(20,10,0,.08)]
        transition-all
        duration-500
        hover:-translate-y-2
        hover:shadow-[0_30px_70px_rgba(20,10,0,.12)]
      "
    >
      <div className="overflow-hidden">
        <img
          src={program.image}
          alt={program.title}
          className="
            w-full
            h-[340px]
            object-cover
            transition-transform
            duration-700
            group-hover:scale-105
          "
        />
      </div>

      <div className="px-8 py-8 text-center">
        <h2
          className="
            text-[30px]
            text-secondary
            tracking-[-0.03em]
          "
        >
          {program.title}
        </h2>
      </div>
    </div>
  </Link>
))}
          </div>
        </div>
      </section>
    </main>
  );
};

export default CorporateJourney;